import React, { FC } from 'react';
import IUrlPickerItem from '../../interfaces/umbracoNodes/urlPickerItem';

import * as StyledCtaTextOnlyBoxes from './ctaTextOnlyBox.styles';

interface Props {
	title: string;
	description: string;
	link: IUrlPickerItem | null;
}

const CtaTextOnlyBox: FC<Props> = ({ title, description, link }) => {
	return (
		<StyledCtaTextOnlyBoxes.Wrapper>
			<StyledCtaTextOnlyBoxes.TextWrapper>
				<StyledCtaTextOnlyBoxes.Title>{title}</StyledCtaTextOnlyBoxes.Title>
				<StyledCtaTextOnlyBoxes.Description>{description}</StyledCtaTextOnlyBoxes.Description>
			</StyledCtaTextOnlyBoxes.TextWrapper>
			<StyledCtaTextOnlyBoxes.TileLink href={link.Url}>{link.Name}</StyledCtaTextOnlyBoxes.TileLink>
		</StyledCtaTextOnlyBoxes.Wrapper>
	);
};

export default CtaTextOnlyBox;
